@use "../../sass/global/global" as *;

.ux-iws-teaser-selectable-download {
    display: flex;
    flex-direction: column;
    padding: 10px 0 28px;
    margin-top: 20px;
    border-bottom: 1px solid $color-gray-borders;

    @media (min-width: 768px) {
        flex-direction: row;
        position: relative;
        padding-left: 50px;
    }

    &__image-container {
        height: 115px;
        max-height: 115px;

        img {
            display: block;
            height: 100%;
            width: auto;
            margin: 0 auto;
        }

        @media (min-width: 768px) {
            width: 80px;
            min-width: 80px;
        }
    }

    &__text-container {
        @media (min-width: 768px) {
            flex-shrink: 1;
            padding-left: 30px;
        }
    }

    &__info-container {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding-top: 20px;
        padding-bottom: 15px;

        @media (min-width: 768px) {
            padding-top: 0;
            padding-bottom: 0;
        }
    }

    &__checkbox-container {
        display: flex;
        align-items: center;

        .ux-checkbox__label--empty {
            margin-right: 15px;
        }

        .ux-checkbox {
            cursor: pointer;
        }

        @media (min-width: 768px) {
            position: absolute;
            top: 10px;
            left: 0;
            width: 50px;
            cursor: pointer;
            height: calc(100% - 30px);
            display: flex;
            align-items: flex-start;
        }
    }

    &__checkbox-container ux-checkbox {
        @media (min-width: 768px) {
            height: 100%;
        }
    }

    &__checkbox-container .ux-checkbox {
        @media (min-width: 768px) {
            cursor: pointer;
            height: 100%;
            width: 50px;
        }
    }

    &--preselected &__checkbox-container {
        display: none;
    }

    &--preselected {
        @media (min-width: 768px) {
            padding-left: 0;
        }
    }
}
